export function buildLandingRoomCards(rooms, section) {
  const ids = section && Array.isArray(section.room_type_ids) ? section.room_type_ids : [];
  if (ids.length === 0 || !Array.isArray(rooms)) return [];
  const overrides = (section && section.overrides) || {};
  const byId = new Map(rooms.map(room => [room.room_type_id, room]));

  return ids
    .map(id => {
      const room = byId.get(id);
      if (!room) return null;
      const override = overrides[id] || {};
      return {
        id,
        name: room.name || '',
        image: override.image || (room.images && room.images[0]) || '',
        price: room.available_rate != null ? room.available_rate : room.base_price,
        capacity: room.max_guests ? `${room.max_guests} Tamu` : '',
        bed: override.bed || '',
        size: override.size || '',
        description: override.description || room.description || '',
        features: (room.amenities || []).slice(0, 5),
      };
    })
    .filter(Boolean);
}
